import axios from "axios";
import { getAuthToken } from "../helpers/local_storage_helpers";
import {
    fpoProcurementsUrl,
    fpoProcurementDetailUrl,
    fpoProcurementApproveUrl,
    fpoProcurementRejectUrl,
    fpoProcurementCorrectUrl,
    fpoProcurementBulkApproveUrl,
    fpoProcurementSummaryUrl,
    fpoStockBatchesUrl,
    fpoStockMovementsUrl,
    fpoStockSummaryUrl,
    fpoFarmerPaymentsUrl,
    fpoLedgerFarmersUrl,
    fpoLedgerFarmerDetailUrl,
    fpoLedgerManualAdjustmentUrl,
} from "../constants/apis";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

// ── Procurement Register ──────────────────────────────────────────

/** GET /fpo/procurements/?page=&search=&status=&… */
export const getProcurements = async (params = {}) => {
    return axios.get(fpoProcurementsUrl, { ...authHeaders(), params });
};

/** GET /fpo/procurements/<id>/ */
export const getProcurement = async (id) => {
    return axios.get(fpoProcurementDetailUrl(id), authHeaders());
};

/** POST /fpo/procurements/ */
export const createProcurement = async (data) => {
    return axios.post(fpoProcurementsUrl, data, authHeaders());
};

/** PATCH /fpo/procurements/<id>/ */
export const updateProcurement = async (id, data) => {
    return axios.patch(fpoProcurementDetailUrl(id), data, authHeaders());
};

/** POST /fpo/procurements/<id>/approve/ — body: { warehouse } */
export const approveProcurement = async (id, data) => {
    return axios.post(fpoProcurementApproveUrl(id), data, authHeaders());
};

/** POST /fpo/procurements/<id>/reject/ — body: { reason } */
export const rejectProcurement = async (id, data = {}) => {
    return axios.post(fpoProcurementRejectUrl(id), data, authHeaders());
};

/** POST /fpo/procurements/<id>/correct/ */
export const correctProcurement = async (id, data) => {
    return axios.post(fpoProcurementCorrectUrl(id), data, authHeaders());
};

/** POST /fpo/procurements/bulk-approve/ — body: { ids: [...], warehouse } */
export const bulkApproveProcurements = async (data) => {
    return axios.post(fpoProcurementBulkApproveUrl, data, authHeaders());
};

/** GET /fpo/procurements/summary/ — returns pending/approved counts + payable */
export const getProcurementSummary = async () => {
    return axios.get(fpoProcurementSummaryUrl, authHeaders());
};

// ── Stock ─────────────────────────────────────────────────────────

/** GET /fpo/stock/batches/?page=&… */
export const getStockBatches = async (params = {}) => {
    return axios.get(fpoStockBatchesUrl, { ...authHeaders(), params });
};

/** GET /fpo/stock/movements/?page=&… */
export const getStockMovements = async (params = {}) => {
    return axios.get(fpoStockMovementsUrl, { ...authHeaders(), params });
};

/** GET /fpo/stock/summary/ — wrapped {status, data} */
export const getStockSummary = async () => {
    return axios.get(fpoStockSummaryUrl, authHeaders());
};

// ── Farmer Payments ───────────────────────────────────────────────

/** GET /fpo/farmer-payments/?page=&… */
export const getFarmerPayments = async (params = {}) => {
    return axios.get(fpoFarmerPaymentsUrl, { ...authHeaders(), params });
};

/** POST /fpo/farmer-payments/ — body: { procurement, amount, mode, reference } */
export const createFarmerPayment = async (data) => {
    return axios.post(fpoFarmerPaymentsUrl, data, authHeaders());
};

// ── Ledger ────────────────────────────────────────────────────────

/** GET /fpo/ledger/farmers/ — returns farmer list with balances */
export const getLedgerFarmers = async (params = {}) => {
    return axios.get(fpoLedgerFarmersUrl, { ...authHeaders(), params });
};

/** GET /fpo/ledger/farmers/<int:id>/ — returns ledger entries for one farmer */
export const getLedgerFarmerEntries = async (farmerId, params = {}) => {
    return axios.get(fpoLedgerFarmerDetailUrl(farmerId), { ...authHeaders(), params });
};

/** POST /fpo/ledger/farmers/<int:id>/manual-adjustment/ — body: { entry_type, amount, description } (fpo_admin only) */
export const postManualLedgerAdjustment = async (farmerId, data) => {
    return axios.post(fpoLedgerManualAdjustmentUrl(farmerId), data, authHeaders());
};
